import classNames from 'classnames';
import { useMenuBalanceContext } from 'moduleBase/modules/menu-balance/hooks/use-menu-balance-context';
import * as React from 'react';
import app from 'srcJs/App';

var Wait = function Wait() {
  var _useMenuBalanceContex = useMenuBalanceContext(),
      menu = _useMenuBalanceContex.menu;

  if (!menu.wait) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classNames('dropdown-flat-list__item', 'dropdown-flat-list__item_small-vertical-padding', 'justify-content-between')
  }, /*#__PURE__*/React.createElement("span", {
    className: "color-858585 mr-3"
  }, app.tForReact('base', 'Wait:')), /*#__PURE__*/React.createElement("span", {
    className: "text-truncate text-dark"
  }, menu.wait));
};

export { Wait };